var map = {
	".": 18342,
	"./": 18342,
	"./Collaborator": 81320,
	"./Collaborator.jsx": 81320,
	"./Collaborator.module.scss": 60881,
	"./SortableCollaborator": 35924,
	"./SortableCollaborator.jsx": 35924,
	"./index": 18342,
	"./index.jsx": 18342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95173;